import { useEffect, useState } from "react";
import Hero from "../components/Hero";
import CardThumb from "../components/CardThumb";
import { faChevronRight } from "@fortawesome/pro-regular-svg-icons";
import {
  faThumbsUp,
  faChalkboardUser,
  faLightbulbExclamationOn,
  faStars,
} from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CardAbout from "../components/CardAbout";
import ScrollTop from "../components/ScrollTop";
import { Loading } from "common/pages";
import "./Home.scss";

export default function Home({ api, account, setAccount }) {
  const [loading, setLoading] = useState(true);

  const [demos, setDemos] = useState([]);
  const [limitDemo, setLimitDemo] = useState(6);
  const [dataSize, setDataSize] = useState(1);

  const callbackFavorite = {
    favorited: (cardId) => {
      setDemos((prev) => {
        return prev.map((cardItem) => {
          if (cardItem.id === cardId) cardItem.favorited = true;
          return cardItem;
        });
      });

      setAccount({ ...account, favorite_count: account.favorite_count + 1 });
    },
    unFavorited: (cardId) => {
      setDemos((prev) => {
        return prev.map((cardItem) => {
          if (cardItem.id === cardId) cardItem.favorited = false;
          return cardItem;
        });
      });

      setAccount({ ...account, favorite_count: account.favorite_count - 1 });
    },
  };

  useEffect(() => {
    setLoading(true);

    api(
      `api/providers/${process.env.REACT_APP_SLUG}/content-videos/?page=1&page_size=${limitDemo}`,
    ).then(({ ok, body }) => {
      if (ok) {
        setDemos(body.data);
        setDataSize(body.data_size);
      }
      setLoading(false);
    });
  }, [api, setDemos, setLoading, limitDemo]);

  return (
    <div className={`home wrapper-login ${loading ? "loading" : ""}`}>
      {!loading ? (
        <>
          <Hero api={api} />
          <section className="demo py-5">
            <div className="bw-event-container">
              <h2 className="bw-event-title">Library</h2>

              <div className="bw-event-row pt-4">
                {demos.length ? (
                  demos.slice(0, limitDemo).map((item, key) => (
                    <div className="bw-event-col" key={key}>
                      <CardThumb
                        api={api}
                        logged={!!account}
                        callbackFavorite={callbackFavorite}
                        card={item}
                      />
                    </div>
                  ))
                ) : (
                  <h3 className="bw-event-col-12 bw-event-no-items-found">
                    No items found
                  </h3>
                )}
              </div>

              {limitDemo < dataSize ? (
                <button
                  className="bw-event-btn bw-event-btn-more"
                  onClick={() => setLimitDemo(limitDemo + 3)}
                >
                  Show more
                  <FontAwesomeIcon
                    icon={faChevronRight}
                    style={{ color: "#1976D2" }}
                  />
                </button>
              ) : null}
            </div>
          </section>

          <section className="about py-5">
            <div className="bw-event-container">
              <h2 className="bw-event-title">About the BW Engagement Portal</h2>
              <div className="wrapper-content">
                <div className="wrapper-cards">
                  <div className="bw-event-row">
                    <div className="bw-event-col">
                      <CardAbout
                        icon={
                          <FontAwesomeIcon
                            icon={faThumbsUp}
                            style={{ color: "#0097A7" }}
                          />
                        }
                        title="Like what you see?"
                      >
                        Did you know the page you’re on right now (yes this very
                        minute) is actually a custom tool designed by BW for the
                        most sophisticated post-event experience? The BW Engagement Portal leverages personalization and AI for a more
                        custom experience for your event attendees
                      </CardAbout>
                    </div>
                    <div className="bw-event-col">
                      <CardAbout
                        icon={
                          <FontAwesomeIcon
                            icon={faChalkboardUser}
                            style={{ color: "#0097A7" }}
                          />
                        }
                        title="How does it work?"
                      >
                        This fully custom content portal can be used as a
                        central hub for your past, present and future events.
                        Built with a focus on clean-flowing information, the
                        Engagement Portal is both event and video platform agnostic,
                        meaning events housed on multiple platforms can be
                        centralized in this one convenient space.
                      </CardAbout>
                    </div>
                    <div className="bw-event-col">
                      <CardAbout
                        icon={
                          <FontAwesomeIcon
                            icon={faStars}
                            style={{ color: "#0097A7" }}
                          />
                        }
                        title="What makes it so special?"
                      >
                        Features of this portal include:
                        <ul>
                          <li>1 click registration for return users</li>
                          <li>data-driven content recommendations</li>
                          <li>bookmarking</li>
                          <li>progressive profiling</li>
                          <li>cognitive search within videos.</li>
                        </ul>
                      </CardAbout>
                    </div>
                    <div className="bw-event-col">
                      <CardAbout
                        icon={
                          <FontAwesomeIcon
                            icon={faLightbulbExclamationOn}
                            style={{ color: "#0097A7" }}
                          />
                        }
                        title="What else can it do?"
                      >
                        The Engagement Portal pulls from all your events and
                        displays specific playlists of content for a thoughtful
                        user experience. Watch analytics are integrated with the
                        reporting engine for robust content metrics- all this to
                        say it looks cool for your attendees and the reporting
                        captures what your stakeholders are looking for.
                      </CardAbout>
                    </div>
                  </div>
                </div>
                <div className="wrapper-featured-info">
                  <h3>In conclusion</h3>
                  <p>
                    We believe that the best way to learn is by doing. Click
                    around and see how the Engagement Portal takes post-event
                    content for all your programs to a new level.
                  </p>
                  <button className="bw-event-btn btn-event-ready">
                    I’m ready to learn more
                  </button>
                </div>
              </div>
            </div>
          </section>
          <ScrollTop />
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
}
